import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from "@angular/core";
import { BvAlign, BvSpace, alignToCss, spaceVar } from "./types";

@Component({
    selector: "bv-stack",
    template: "<ng-content></ng-content>",
    styles: [
        `
      :host {
        display: flex;
        flex-direction: column;
        min-width: 0;
      }
    `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BvStackComponent {
  @Input() space: BvSpace = "0";
  @Input() align?: BvAlign;

  @HostBinding("style.gap")
  get gapStyle(): string {
    return spaceVar(this.space);
  }

  @HostBinding("style.align-items")
  get alignStyle(): string | null {
    return this.align ? alignToCss(this.align) : null;
  }
}
